/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Deleted_Terms_SuccessInputs */

const en_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Deleted ${i?.count} term(s) successfully`)
};

const fr_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Suppression réussie de ${i?.count} terme(s)`)
};

const de_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Term(e) erfolgreich gelöscht`)
};

const it_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eliminati correttamente ${i?.count} termini`)
};

const ru_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Термин(ы) ${i?.count} успешно удален(ы).`)
};

const es_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se eliminaron ${i?.count} términos correctamente`)
};

const zh_cn2_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已成功删除 ${i?.count} 术语`)
};

const ja_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 個の用語を削除しました`)
};

const hi_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} पद सफलतापूर्वक हटा दिए गए`)
};

const pt_pt2_knp_terms_deleted_terms_success = /** @type {(inputs: Knp_Terms_Deleted_Terms_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Termo(s) ${i?.count} excluído(s) com sucesso`)
};

/**
* | output |
* | --- |
* | "Deleted {count} term(s) successfully" |
*
* @param {Knp_Terms_Deleted_Terms_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_deleted_terms_success = /** @type {((inputs: Knp_Terms_Deleted_Terms_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Deleted_Terms_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_deleted_terms_success(inputs)
	if (locale === "de") return de_knp_terms_deleted_terms_success(inputs)
	if (locale === "it") return it_knp_terms_deleted_terms_success(inputs)
	if (locale === "ru") return ru_knp_terms_deleted_terms_success(inputs)
	if (locale === "es") return es_knp_terms_deleted_terms_success(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_deleted_terms_success(inputs)
	if (locale === "ja") return ja_knp_terms_deleted_terms_success(inputs)
	if (locale === "hi") return hi_knp_terms_deleted_terms_success(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_deleted_terms_success(inputs)
	return en_knp_terms_deleted_terms_success(inputs)
});